import { render, staticRenderFns } from "./viewBankCard.vue?vue&type=template&id=33a3ea6a&scoped=true"
import script from "./viewBankCard.vue?vue&type=script&lang=js"
export * from "./viewBankCard.vue?vue&type=script&lang=js"
import style0 from "./viewBankCard.vue?vue&type=style&index=0&id=33a3ea6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a3ea6a",
  null
  
)

export default component.exports